package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.auth.AppearanceDto
import com.evoapps.evoshift.data.dto.auth.UserDto
import com.evoapps.evoshift.domain.model.Appearance
import com.evoapps.evoshift.domain.model.User

class UserMapper(
    private val engagementMapper: EngagementMapper
) {
    fun toDomain(dto: UserDto, emailFromAuth: String?): User {
        return User(
            uid = dto.uid,
            displayName = dto.displayName,
            photoUrl = dto.photoUrl,
            engagements = dto.engagements.mapValues { (workplaceId, engagementDto) ->
                engagementMapper.toDomain(engagementDto, workplaceId)
            },
            isShadow = dto.isShadow,
            createdAt = dto.createdAt,
            isSetupComplete = dto.isSetupComplete,
            language = dto.language,
            languagePreference = dto.languagePreference,
            appearance = dto.appearance?.let { Appearance.parse(it.base, it.accent) }
        )
    }

    fun toDto(domain: User): UserDto {
        return UserDto(
            uid = domain.uid,
            displayName = domain.displayName,
            photoUrl = domain.photoUrl,
            engagements = domain.engagements.mapValues { (_, engagement) ->
                engagementMapper.toDto(engagement)
            },
            isShadow = domain.isShadow,
            createdAt = domain.createdAt,
            isSetupComplete = domain.isSetupComplete,
            language = domain.language,
            languagePreference = domain.languagePreference,
            appearance = domain.appearance?.let { AppearanceDto(it.base.name, it.accent.name) }
        )
    }
}